/**
 * Just Carry On — cart.
 *
 * Shopify's AJAX Cart API with the Section Rendering API: every change asks Shopify for
 * the freshly rendered cart drawer (and the cart page's section when on /cart), so the
 * markup and prices always come from Liquid and never from a second template here.
 * Without JavaScript the same controls fall back to forms and links.
 */
(function () {
  'use strict';

  var JCO = (window.JustCarryOn = window.JustCarryOn || {});
  var routes = JCO.routes || {};
  var strings = JCO.strings || {};

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  var drawer = function () { return $('[data-cart-drawer]'); };
  var scrim = function () { return $('[data-scrim]'); };

  /** Section ids to re-render: the drawer always, the cart page's main section when present. */
  function sectionIds() {
    var ids = ['cart-drawer'];
    var page = $('[data-cart-page]');
    var wrapper = page && page.closest('.shopify-section');
    if (wrapper && wrapper.id) ids.push(wrapper.id.replace(/^shopify-section-/, ''));
    return ids;
  }

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var error = new Error(data.description || data.message || strings.cartError);
          error.data = data;
          throw error;
        }
        return data;
      });
    });
  }

  /** Swaps in freshly rendered sections and refreshes every count on the page. */
  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        var fresh = doc.querySelector('[data-cart-drawer]');
        var current = drawer();
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      } else {
        var target = document.getElementById('shopify-section-' + id);
        var incoming = doc.getElementById('shopify-section-' + id) || doc.querySelector('.shopify-section');
        if (target && incoming) target.innerHTML = incoming.innerHTML;
      }
    });
  }

  function updateCounts(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (el.classList.contains('mbar__pip')) el.classList.toggle('is-on', count > 0);
      else el.hidden = count === 0;
    });
  }

  function refreshCount() {
    return fetch((routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { updateCounts(cart.item_count); return cart; });
  }

  /* ------------------------------------------------------------------ *
   * Drawer
   * ------------------------------------------------------------------ */
  JCO.openCart = function (trigger) {
    var el = drawer();
    if (!el) { window.location.href = routes.cart || '/cart'; return; }
    JCO.openLayer(el, { scrim: scrim(), trigger: trigger });
  };
  JCO.closeCart = function () { JCO.closeLayer(drawer()); };

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-cart-open]');
    if (opener && JCO.cartType !== 'page' && drawer() && !$('[data-cart-page]')) {
      event.preventDefault();
      JCO.openCart(opener);
      return;
    }
    if (event.target.closest('[data-cart-close]')) { JCO.closeCart(); return; }
    if (event.target.matches('[data-scrim]')) JCO.closeCart();
  });

  /* ------------------------------------------------------------------ *
   * Adding
   * ------------------------------------------------------------------ */
  JCO.addToCart = function (items, opts) {
    opts = opts || {};
    return post((routes.cartAdd || '/cart/add') + '.js', {
      items: items,
      sections: sectionIds().join(','),
      sections_url: window.location.pathname,
    }).then(function (data) {
      renderSections(data.sections);
      return refreshCount().then(function () { return data; });
    });
  };

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-product-form]');
    if (!form) return;
    var submitter = event.submitter;
    var buyNow = submitter && submitter.hasAttribute('data-buy-now');
    var data = new FormData(form);
    var id = parseInt(data.get('id'), 10);
    if (!id) return;
    event.preventDefault();

    var quantity = parseInt(data.get('quantity') || '1', 10) || 1;
    var addButton = $('[data-add-button]', form);
    var label = addButton && $('[data-add-label]', addButton);
    var original = label ? label.textContent : '';
    if (submitter) submitter.setAttribute('aria-busy', 'true');
    if (label && !buyNow) label.textContent = strings.adding || original;

    JCO.addToCart([{ id: id, quantity: quantity }])
      .then(function () {
        if (buyNow) {
          window.location.href = submitter.value || '/checkout';
          return;
        }
        if (JCO.cartType === 'page') {
          window.location.href = routes.cart || '/cart';
          return;
        }
        // Added from the quick view: it gives way to the drawer, which will hand focus
        // back to the product card the quick view was opened from.
        var quickView = form.closest('[data-quick-view]');
        if (quickView) JCO.closeLayer(quickView);
        JCO.openCart(quickView ? null : submitter);
        if (JCO.toast) JCO.toast(strings.added || 'Added');
      })
      .catch(function (err) {
        if (JCO.toast) JCO.toast(err.message || strings.cartError);
      })
      .finally(function () {
        if (submitter) submitter.removeAttribute('aria-busy');
        if (label) label.textContent = original;
      });
  });

  /* Suggestions in the drawer */
  document.addEventListener('click', function (event) {
    var add = event.target.closest('[data-upsell-add]');
    if (!add) return;
    event.preventDefault();
    add.disabled = true;
    JCO.addToCart([{ id: parseInt(add.getAttribute('data-variant-id'), 10), quantity: 1 }])
      .catch(function (err) {
        add.disabled = false;
        if (JCO.toast) JCO.toast(err.message || strings.cartError);
      });
  });

  /* ------------------------------------------------------------------ *
   * Changing lines (drawer and cart page share the markup)
   * ------------------------------------------------------------------ */
  function changeLine(line, quantity) {
    var key = line.getAttribute('data-key');
    line.classList.add('is-updating');
    return post((routes.cartChange || '/cart/change') + '.js', {
      id: key,
      quantity: quantity,
      sections: sectionIds().join(','),
      sections_url: window.location.pathname,
    }).then(function (cart) {
      renderSections(cart.sections);
      updateCounts(cart.item_count);
    }).catch(function (err) {
      line.classList.remove('is-updating');
      if (JCO.toast) JCO.toast(err.message || strings.cartError);
    });
  }

  document.addEventListener('click', function (event) {
    var line = event.target.closest('[data-cart-line]');
    if (!line) return;
    var step = event.target.closest('[data-qty-step]');
    var remove = event.target.closest('[data-line-remove]');
    if (!step && !remove) return;
    event.preventDefault();
    if (remove) { changeLine(line, 0); return; }
    var input = $('[data-qty-input]', line);
    var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
    input.value = next;
    changeLine(line, next);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-line] [data-qty-input]');
    if (input) {
      changeLine(input.closest('[data-cart-line]'), Math.max(0, parseInt(input.value, 10) || 0));
      return;
    }
    var note = event.target.closest('[data-cart-note]');
    if (note) post((routes.cartUpdate || '/cart/update') + '.js', { note: note.value }).catch(function () {});
  });

  /* The cart page submits its form for checkout; stop Enter in a quantity field from
     doing so — the change event above has already saved the quantity. */
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && event.target.closest && event.target.closest('[data-cart-line] [data-qty-input]')) {
      event.preventDefault();
      event.target.blur();
    }
  });
})();
